import { Routes } from '@angular/router';
import { titleFormatter } from '@core/utils/general.utils';

export const snapshotRoutes: Routes = [
  {
    path: 'snapshots',
    title: titleFormatter('Snapshots'),
    data: { title: 'Snapshots' },
    loadComponent: () => import('./pages/Home/Home.component').then((m) => m.SnapshotsHomeComponent),
  },
];
